const links = [
  {
    name: 'Home',
    href: '#intro',
  },
  {
    name: 'Portfolio',
    href: '#portfolio',
  },
  {
    name: 'Skills',
    href: '#works',
  },
  {
    name: 'Testimonials',
    href: '#testimonials',
  },
  {
    name: 'Contact',
    href: '#contact',
  },
];

export default links;
